module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "SP",
    attrs: {
      "id": "ack"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "FM-Head-fmh"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_vii",
      "title": "vii"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-No-Indent-fmtx1"
  }, [_vm._v("Thanks to so many friends who have been there through good times and bad: Connie Jo Brown Gernhofer, Carolyn Clemens, Annelise Robey, Mary Rast, Chandler Schwede, Tris Ziegler, Devynn Grubby, Steve Troha, Isaac Babik, Lucinda Denton, Denise Whitaker, Brett Winston, Jordan Lyon, Brian Hazel, Jennifer Mai, Elizabeth Flynn, Kristin Murphy, Bill Elliott, Basia Atkins, and my dear Nicoletta Poungias. You have all meant so much to me!")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_vm._v("Two people helped, inestimably, to give me my start: Cristine Grace and Melissa Senate. I owe you so much!")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_vm._v("So many thanks to Jen Enderlin, for carving so many of my ideas into books, and to Holly Ingraham, for stepping in with such great humor to get my words in line!")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_vm._v("Love and thanks to my mother, Connie Atkins; and to my sisters, Elaine Fox and Jacquelyn Vincenta.")]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_vm._v("Adam Smiarowski, you came out of nowhere and made everything so much better. I love you! "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("(Ja kocham ć")]), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("iebie!)")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Text-fmtx"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_viii",
      "title": "viii"
    }
  }, [_vm._v("And, as always, thanks to my truly wonderful children. Paige, you are hilarious and inspire me daily. No one words things better than you do! And Jack, you are so incredibly talented—writing, singing, playing music—I can’t wait to see what you do next. Both of you: your father would be so proud of you.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-466fc50a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknowledgments.vue
// module id = 72
// module chunks = 0